export const hasPropertyImage = (property) => {
  if (!property) return false;
  if (
    property.DeskImg &&
    Array.isArray(property.DeskImg) &&
    property.DeskImg.length > 0 &&
    property.DeskImg[0] &&
    typeof property.DeskImg[0] === "string" &&
    property.DeskImg[0].trim() !== ""
  ) {
    return true;
  }
  if (
    property.photos &&
    Array.isArray(property.photos) &&
    property.photos.length > 0 &&
    property.photos[0] &&
    typeof property.photos[0] === "string" &&
    property.photos[0].trim() !== ""
  ) {
    return true;
  }
  if (
    property.images &&
    Array.isArray(property.images) &&
    property.images.length > 0 &&
    property.images[0] &&
    typeof property.images[0] === "string" &&
    property.images[0].trim() !== ""
  ) {
    return true;
  }
  if (
    property.mobileimage &&
    Array.isArray(property.mobileimage) &&
    property.mobileimage.length > 0 &&
    property.mobileimage[0] &&
    typeof property.mobileimage[0] === "string" &&
    property.mobileimage[0].trim() !== ""
  ) {
    return true;
  }
  if (
    property.thumbnail &&
    typeof property.thumbnail === "string" &&
    property.thumbnail.trim() !== ""
  ) {
    return true;
  }
  return false;
};

export const sortPropertiesWithImagesFirst = (list) => {
  if (!Array.isArray(list)) return [];
  return [...list].sort((a, b) => {
    const aHas = hasPropertyImage(a);
    const bHas = hasPropertyImage(b);
    if (aHas && !bHas) return -1;
    if (!aHas && bHas) return 1;
    return 0;
  });
};

export const getPropertyInfoUrl = (property) => {
  if (!property) return "/";
  const propertyId = property.propertyID || property._id;
  const apartName =
    property.apartment && typeof property.apartment === "string" && property.apartment.trim() !== ""
      ? property.apartment.trim()
      : propertyId || "property";
  return `/property-info/${apartName}/${propertyId}`;
};
